import React from 'react'
import PropTypes from "prop-types";
import classnames from 'classnames'

import { i18n } from 'core/i18n'

import './offerCard.scss'

const LANDING_OFFERS_DEPOSIT_PRODUCT = 'deposits'

export const OfferCard = ({
    isFullWidth = false,
    tin,
    tae,
    amount,
    grossInterest,
    expirationDate,
    months,
    productType,
    color,
    supIndex,
    isTheMostProfitable,
    isFullInterestRate,
    onAction = () => {},
}) => {
    const { FormattedText } = i18n;
    
    const offerCardClasses = classnames('offer-card', {
        'offer-card--full': isFullWidth,
        'offer-card--cc': __CONTACT_CENTER__
    });

    const renderExpriationDate = () => {
        return (
            <div className="offer-card__chip">
                <FormattedText value="contractsView-contractView_depositOfferEndDate" injectedStrings={[expirationDate]} />
            </div>
        )
    }

    const renderBenefits = () => {
        switch(productType) {
            case LANDING_OFFERS_DEPOSIT_PRODUCT:
                return (
                    <div className="offer-card__gross-interest">
                        <FormattedText value="contractsView-contractView_depositOfferImport" injectedStrings={[amount]} />
                        <br />
                        <FormattedText value="contractsView-contractView_depositOfferGrossInterest" injectedStrings={[grossInterest]} />
                    </div>
                )
        }
    }

    const renderInterestRate = () => {
        if (isFullInterestRate) {
            const isSameTinTae = tin === tae
            return (
                <React.Fragment>
                    <strong style={{ backgroundColor: color }}>
                        <FormattedText value="contractsView-contractView_depositOfferDetailTae" injectedStrings={[tae]} />
                        <sup>{ supIndex }</sup>
                    </strong>
                    {
                        isSameTinTae
                            ? <FormattedText value="contractsView-contractView_depositOfferDetailTinIsSameTae" />
                            : <FormattedText value="contractsView-contractView_depositOfferDetailTin" injectedStrings={[tin]} />
                    }
                </React.Fragment>
            )
        }

        return (
            <React.Fragment>
                <strong style={{ backgroundColor: color }}>
                    { tin }
                </strong>
                <div>
                    <FormattedText value="contractsView-contractView_depositOfferDetailTinOnlyText" />
                    <sup>{ supIndex }</sup>
                </div>
            </React.Fragment>
        )
    }

    return (
        <div className={offerCardClasses}>
            <div className="offer-card__head">
                <div className="offer-card__head__decoration" style={{ backgroundColor: color }} />
                <h3 className="offer-card__head__title">
                    <FormattedText value="contractsView-contractView_depositOfferTitle" />
                    <strong>
                        <FormattedText value="contractsView-contractView_depositOfferSubtitle" injectedStrings={[months]} />
                    </strong>
                </h3>
                {
                    isTheMostProfitable && (
                        <div className="offer-card__higher-profitability">
                            <FormattedText value="contractsView-contractView_depositOfferMoreProfitability" />
                        </div>
                    )
                }
            </div>
            <div className="offer-card__body">
                <div className="offer-card__details">
                    {
                        LANDING_OFFERS_DEPOSIT_PRODUCT === productType && renderExpriationDate()
                    }
                    <div className="offer-card__details__rate">
                        <FormattedText value="contractsView-contractView_depositOfferDetailText" />
                        {renderInterestRate()}
                    </div>
                </div>

                {renderBenefits()}
            </div>
            <div className="offer-card__footer">
                <button className="buttons-base buttons-base--regular buttons-base--primary" onClick={onAction}>
                    <FormattedText value="contractsView-contractView_depositOfferCTA" />
                </button>
            </div>
        </div>
    )
}

OfferCard.propTypes = {
    itemNumber: PropTypes.number.isRequired,
    isFullWidth: PropTypes.bool.isRequired,
    isAccount: PropTypes.bool,
    tin: PropTypes.string.isRequired,
    tae: PropTypes.string.isRequired,
    amount: PropTypes.string.isRequired,
    grossInterest: PropTypes.string.isRequired,
    months: PropTypes.string.isRequired,
    isTheMostProfitable: PropTypes.bool.isRequired,
    color: PropTypes.string.isRequired,
    supIndex: PropTypes.number.isRequired,
    expirationDate: PropTypes.string.isRequired,
    onAction: PropTypes.func.isRequired,
    isFullInterestRate: PropTypes.bool.isRequired,
};
